import { render } from "./RoomsView.vue?vue&type=template&id=318a8e0a"
import script from "./RoomsView.vue?vue&type=script&lang=js"
export * from "./RoomsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__